<template>
  <div>
    <!-- 统一内页Banner设计，极具品牌感 -->
    <PageBanner :title="know.title || '相关知识'" subtitle="中泉环保 · 绿色工业环保标准与技术文章库" />

    <section class="page-section know-detail">
      <div class="know-detail__card">
        <div class="know-detail__header">
          <span class="badge">🍀 行业知识</span>
          <span class="know-detail__time">📅 发布时间：{{ know.time }}</span>
        </div>
        <div class="know-detail__content">
          <p v-for="(item, i) in know.detail" :key="i" class="text-paragraph">
            {{ item }}
          </p>
        </div>
        <div class="know-detail__footer">
          <p class="disclaimer">免责声明：部分技术性文章来源于公开环保行业标准，本站仅作科普和设备配置参考，具体工程方案请以我司工程师1对1工况设计为准。</p>
          <router-link to="/knows" class="btn-back">返回知识列表 <i class="el-icon-back"></i></router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue'
import { getStaticKnowById } from '@/constants/staticData'

export default {
  name: 'KnowDetail',
  components: { PageBanner },
  data () {
    return {
      know: {}
    }
  },
  created () {
    this.know = getStaticKnowById(this.$route.params.id)
  }
}
</script>

<style lang="scss" scoped>
.know-detail {
  max-width: 900px;
  margin: 0 auto;
  padding: 3rem 1.5rem;

  &__card {
    background: #fff;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    border: 1px solid var(--color-border);
    padding: 3rem;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--color-border);
    padding-bottom: 1.5rem;
    margin-bottom: 2rem;
    flex-wrap: wrap;
    gap: 1rem;

    .badge {
      background: var(--color-primary-light);
      color: var(--color-primary-dark);
      font-size: 0.8rem;
      font-weight: 700;
      padding: 0.3rem 0.8rem;
      border-radius: 4px;
    }
  }

  &__time {
    color: var(--color-text-light);
    font-size: 0.875rem;
    font-weight: 500;
  }

  &__content {
    .text-paragraph {
      line-height: 1.95;
      color: var(--color-text);
      font-size: 1.05rem;
      margin-bottom: 1.5rem;
      text-align: justify;
      text-indent: 2em; // Standard Chinese paragraph layout
    }
  }

  &__footer {
    border-top: 1px dashed var(--color-border);
    padding-top: 2rem;
    margin-top: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;

    .disclaimer {
      font-size: 0.8rem;
      color: var(--color-text-light);
      line-height: 1.6;
      text-align: left;
      margin: 0;
    }

    .btn-back {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.95rem;
      font-weight: 700;
      color: var(--color-primary-dark);
      text-decoration: none;
      border: 1px solid var(--color-primary);
      padding: 0.5rem 1.5rem;
      border-radius: var(--radius-sm);
      transition: all 0.25s;

      &:hover {
        background: var(--color-primary-light);
        box-shadow: var(--shadow-sm);
      }
    }
  }
}

@media (max-width: 576px) {
  .know-detail {
    padding: 1.5rem 1rem;

    &__card {
      padding: 1.5rem;
    }
  }
}
</style>
